import { entityGenderEnum, entityRoleEnum, entityVerificationStatusEnum } from "../../enums/entity.enum";

export function fetchUserFollowersRequestParamsFormatter(
  limit: number,
  offset: number,
  location?: string | null,
  country?: string | null,
  gender?: string | null,
  verificationStatus?: string | null,
  entityRole?: string | null,
  nationalityId?: number | "" | null | undefined,
  filters?: { [key: string]: any }
): string {
  let queryParams = `?limit=${limit}&offset=${offset}`;

  if (location) queryParams += `&countryId=${location}`;
  if (country) queryParams += `&nationalityId=${country}`;
  if (gender) queryParams += `&gender=${gender}`;
  if (verificationStatus) queryParams += `&verificationStatus=${verificationStatus}`;
  if (entityRole) queryParams += `&role=${entityRole.toUpperCase()}`;
  if (nationalityId) queryParams += `&nationalityId=${nationalityId}`;

  if (filters) {
    for (const [key, value] of Object.entries(filters)) {
      let encodedValue;
      if (Array.isArray(value)) {
        encodedValue = value.filter((v) => v !== null && v !== "").join("-");
      } else {
        encodedValue = value;
      }

      if (encodedValue) {
        queryParams += `&${encodeURIComponent(key)}=${encodeURIComponent(encodedValue)}`;
      }
    }
  }

  return queryParams;
}

export function getFriendsRequestParamsFormatter(
  limit: number,
  offset: number,
  location?: string | null,
  country?: string | null,
  gender?: string | null,
  verificationStatus?: string | null,
  entityRole?: string | null,
  nationalityId?: number | "" | null | undefined,
  filters?: { [key: string]: any }
): string {
  let queryParams = `?limit=${limit}&offset=${offset}`;

  if (location) queryParams += `&countryId=${location}`;
  if (country) queryParams += `&nationalityId=${country}`;
  if (gender) queryParams += `&gender=${gender}`;
  if (verificationStatus) queryParams += `&verificationStatus=${verificationStatus}`;
  if (entityRole) queryParams += `&role=${entityRole.toUpperCase()}`;
  if (nationalityId) queryParams += `&nationalityId=${nationalityId}`;

  if (filters) {
    for (const [key, value] of Object.entries(filters)) {
      let encodedValue;
      if (Array.isArray(value)) {
        encodedValue = value.filter((v) => v !== null && v !== "").join("-");
      } else {
        encodedValue = value;
      }

      if (encodedValue) {
        queryParams += `&${encodeURIComponent(key)}=${encodeURIComponent(encodedValue)}`;
      }
    }
  }

  return queryParams;
}

export function searchUsersRequestParamsFormatter(
  limit: number,
  offset: number,
  searchValue?: string | null,
  countryId?: string | null,
  nationalityId?: string | undefined,
  gender?: string | null,
  verificationStatus?: string | null,
  role?: string | null,
  trending?: boolean | null,
  isFollowing?: boolean | null
): string {
  let queryParams = `?limit=${limit}&offset=${offset * limit}`;

  if (searchValue) queryParams += `&name=${searchValue}`;
  if (countryId) queryParams += `&countryId=${countryId}`;
  if (nationalityId) queryParams += `&nationalityId=${nationalityId}`;
  if (gender) queryParams += `&gender=${gender}`;
  if (verificationStatus) queryParams += `&verificationStatus=${verificationStatus}`;
  if (role) queryParams += `&role=${role.toUpperCase()}`;
  if (trending) queryParams += `&trendingStatus=TRENDING_THIS_MONTH`;
  if (isFollowing) queryParams += `&isFollowing=${isFollowing}`;

  return queryParams;
}

export function searchGroupsRequestParamsFormatter(
  limit: number,
  offset: number,
  searchValue?: string | null,
  countryId?: string | null,
  nationalityId?: string | undefined,
  gender?: string | null,
  verificationStatus?: string | null,
  role?: string | null,
  trending?: boolean | null,
  isFollowing?: boolean | null
): string {
  let queryParams = `?limit=${limit}&offset=${offset * limit}`;

  if (searchValue) queryParams += `&name=${searchValue}`;
  if (countryId) queryParams += `&countryId=${countryId}`;
  if (nationalityId) queryParams += `&nationalityId=${nationalityId}`;
  if (gender) queryParams += `&gender=${gender}`;
  if (verificationStatus) queryParams += `&verificationStatus=${verificationStatus}`;
  if (role) queryParams += `&role=${role.toUpperCase()}`;
  if (trending) queryParams += `&trendingStatus=TRENDING_THIS_MONTH`;
  if (isFollowing) queryParams += `&isFollowing=${isFollowing}`;

  return queryParams;
}

export function getUsersForExploreGetStarsRequestParamsFormatter(offset: number): string {
  // return `?limit=10&offset=${offset * 10}&isFollowing=true&verificationStatus=VERIFIED`;
  return `?limit=10&offset=${offset * 10}&verificationStatus=VERIFIED`;
}

export const fetchUserFollowingRequestParamsFormatter = (params: {
  limit: number;
  offset: number;
  location?: string | null;
  country?: string | null;
  gender?: entityGenderEnum | string | null;
  verificationStatus?: entityVerificationStatusEnum | string | null;
  entityRole?: entityRoleEnum | string | null;
  nationalityId?: number | null;
  filters?: Record<string, any>;
}) => {
  const { limit, offset, location, country, gender, verificationStatus, entityRole, nationalityId, filters } = params;

  let queryParams = `?limit=${limit}&offset=${offset * 12}`;

  if (location) queryParams += `&countryId=${location}`;
  if (country) queryParams += `&nationalityId=${country}`;
  if (gender) queryParams += `&gender=${gender}`;
  if (verificationStatus) queryParams += `&verificationStatus=${verificationStatus}`;
  if (entityRole) queryParams += `&role=${entityRole.toUpperCase()}`;
  if (nationalityId) queryParams += `&nationalityId=${nationalityId}`;

  if (filters) {
    for (const [key, value] of Object.entries(filters)) {
      let encodedValue;
      if (Array.isArray(value)) {
        encodedValue = value.filter((v) => v !== null && v !== "").join("-");
      } else {
        encodedValue = value;
      }
      if (encodedValue) {
        queryParams += `&${encodeURIComponent(key)}=${encodeURIComponent(encodedValue)}`;
      }
    }
  }

  return queryParams;
};

export function getUsersForGroupRequestParamsFormatter(offset: number, searchValue: string): string {
  return `?limit=10&offset=${offset * 10}${searchValue && `&name=${searchValue}`}`;
}

export function getComparedUsersListRequestParamsFormatter(compareIds: string): string {
  return `?userIds=${compareIds}`;
}
